import type { HubAddressTag } from '../../lib/api/domains/technicianHub';

/**
 * Anzeige-Labels und -Farben für Adress-Typ-Tags eines weclapp-Standorts
 * (Haupt-/Rechnungs-/Lieferanschrift). Gemeinsam genutzt von CustomerInfoModal
 * und CustomerDetailPage, damit die Badge-Darstellung konsistent bleibt.
 */
export const ADDRESS_TAG_LABELS: Record<HubAddressTag, string> = {
  PRIME: 'Haupt',
  INVOICE: 'Rechnung',
  DELIVERY: 'Lieferung',
};

export const ADDRESS_TAG_COLORS: Record<HubAddressTag, string> = {
  PRIME: 'gray',
  INVOICE: 'blue',
  DELIVERY: 'teal',
};
